import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const companyList = async () => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_SUPER_SETTING_COMPANY_LIST
  );
  const rowData = await response?.data;
  // console.log("🚀 ~ companyList ~ rowData:", rowData?.data)

  const formattedCompany = Object.entries(rowData.data || {});
  // console.log("🚀 ~ companyList ~ formattedCompany:", formattedCompany)
  const companyObj = Object.fromEntries(Object.entries(rowData.data || {}));
  //    console.log("🚀 ~ companyList ~ companyObj:", companyObj);

  const data = formattedCompany.map((item) => {
    // console.log("item::",item[1]);
    return {
      id: item[1],
      code: item[1],
      name: item[1],
      owner: item[1],
      email: item[1],
    };
  });
  console.log("🚀 ~ data ~ data:", data);
};

// GET_ALL_COUNTRIES
// Get Leave Type
export const getAllCountries = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_ALL_COUNTRIES,
    params
  );

  console.log(
    "🚀 ~ SuperSettingRepo.ts:40 ~ getAllCountries ~ response:",
    response
  );

  return response?.data;
};

export const addCountry = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.SETTING.ADD_COUNTRY, body);
};
export const updateCountry = async (body?: any) => {
  return axiosInstance.put(API_ENDPOINTS.SETTING.UPDATE_COUNTRY, body);
};

export const getRolesList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_ROLES_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ SuperSettingRepo.ts:56 ~ getRolesList ~ response:",
    response
  );
  return response?.data;
};

// ADD_ROLES
export const addRoles = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.SETTING.ADD_ROLES, body);
};

// GET_ROLES_PERMISSION
export const getRolesPermissions = async () => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_ROLES_PERMISSION
  );

  console.log(
    "🚀 ~ SuperSettingRepo.ts:74 ~ getRolesPermissions ~ response:",
    response
  );

  return response?.data;
};

// UPDATE_ROLES
export const updateRoles = async (body?: any) => {
  return axiosInstance.put(API_ENDPOINTS.SETTING.UPDATE_ROLES, body);
};

// GET_CURRENCIES_LIST
export const getCurrenciesList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SETTING.GET_CURRENCIES_LIST,
    params
  );

  console.log(
    "🚀 ~ SuperSettingRepo.ts:96 ~ getCurrenciesList ~ response:",
    response
  );

  return response?.data;
};

// ADD_CURRENCY;

export const addCurrency = async (body?: any) => {
  return axiosInstance.post(API_ENDPOINTS.SETTING.ADD_CURRENCY, body);
};

// UPDATE_CURRENCY
export const updateCurrency = async (id?: string | number, body?: any) => {
  return axiosInstance.put(
    `${API_ENDPOINTS.SETTING.UPDATE_CURRENCY}/${id}`,
    body
  );
};
